/**
 * Utility function for the Webapp.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */
let cachedUri: string | undefined

export class WebAppUtil {
  /**
   * Return the current environment (dev, staging, production).
   */
  static getEnv() {
    if (typeof import.meta?.env !== 'undefined') {
      return import.meta.env
    }

    if (typeof process !== 'undefined' && process.env) {
      return process.env
    }

    throw new Error('env is not defined')
  }

  /**
   * Retyurn the base URI of the webapp.
   */
  static getApiBaseUri(): string {
    if (cachedUri) return cachedUri

    if (
      typeof import.meta !== 'undefined' &&
      import.meta.env?.VITE_API_BASE_URI
    ) {
      cachedUri = import.meta.env.VITE_API_BASE_URI
      return cachedUri ?? ''
    }

    if (typeof process !== 'undefined' && process.env?.VITE_API_BASE_URI) {
      cachedUri = process.env.VITE_API_BASE_URI
      return cachedUri ?? ''
    }

    throw new Error('VITE_API_BASE_URI is not defined')
  }
}
